import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import MenuIcon from "@mui/icons-material/Menu";
// import LanguageSelect from "./LanguageSelect";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useHistory } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import Logout from "@mui/icons-material/Logout";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { logout, fetchProfile } from "../redux/actions/userActionCreators";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Settings from "@mui/icons-material/Settings";
import LockResetOutlinedIcon from "@mui/icons-material/LockResetOutlined";
import ProfileSettings from "../pages/profileSettings/ProfileSettings";
import ChangePassword from "../pages/profileSettings/ChangePassword";
import { useMediaQuery } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import {
  fetchAllNotifications,
  // fetchAllNotifications,
  updateNotification,
} from "../redux/actions/notificationsActionCreator";
import { setOpenInvitationModal } from "../redux/actions/confirmInvitationActionCreators";

import { translate } from "../utils/utils";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import {
  getOrganizatonMetricsById,
  setOrganizationId,
} from "../redux/actions/organizationProfileCreators";
import { initializeSocketListeners } from "../redux/actions/notificationsActionCreator";

function AppBarLabel(label, toggleAside) {
  const [anchorElUser, setAnchorElUser] = useState(false);
  const [anchorNotif, setAnchorNotif] = useState(false);
  const [openProfileSettings, setOpenProfileSettings] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [totalNotifs, setTotalNotifs] = useState(0);
  const isMobile = useMediaQuery("(max-width:900px)");
  const history = useHistory();
  const params = useParams();

  const routesWithoutTitle = [
    "/profile-organization",
    "/Already-Answered",
    "/export/risk_profile",
  ];
  const routeWithoutParams = [
    // `/risk/${params.riskId}`,
    `/make-quizz/${params.quizzId}`,
    `/make-usecase/${params.caseId}`,
    "/export/risk_profile",
  ];

  const dispatch = useDispatch();

  const storedUser = localStorage.getItem("user");
  let parsedUser = {};
  if (storedUser) {
    try {
      parsedUser = JSON.parse(storedUser);
    } catch (e) {
      parsedUser = {};
    }
  }
  const avatar = parsedUser?.avatar_url;
  const role = parsedUser?.role;

  const profileSettings = localStorage.getItem("profile_settings");

  const profile = useSelector((state) => state.user.profile);
  const notifications = useSelector((state) => state.notifications.all);

  useEffect(() => {
    if (profileSettings === "true") {
      dispatch(fetchProfile());
      setOpenProfileSettings(true);
    }
  }, [dispatch, profileSettings]);

  useEffect(() => {
    // No token argument: the socket reads the current one at every connection
    // attempt and re-authenticates itself when it moves, so there is nothing
    // here to capture - which is what this effect used to do at mount, with a
    // localStorage read that has returned null since FE-1 (F-28).
    dispatch(initializeSocketListeners());
  }, [dispatch]);

  useEffect(() => {
    if (
      role === "admin" ||
      role === "enterprise_admin" ||
      role === "cytailor_admin" ||
      role === "enterprise_user"
    ) {
      dispatch(fetchAllNotifications());
    }
  }, [dispatch, role]);

  useEffect(() => {
    if (
      role === "admin" ||
      role === "enterprise_admin" ||
      role === "cytailor_admin" ||
      role === "enterprise_user"
    ) {
      dispatch(fetchProfile());
    }
  }, [dispatch, role]);

  const location = useLocation();
  const { t } = useTranslation();

  const title = location.pathname.substring(1);
  const normalizedPath = location.pathname.replace(/\/+$/, "");
  const displayTitle =
    normalizedPath === "/risk-assessment" ||
    normalizedPath.startsWith("/risk-assessment/")
      ? "Hypotheses"
      : t(title);

  useEffect(() => {
    setTotalNotifs(notifications?.filter((el) => el.is_read === false).length);
  }, [notifications]);

  const shouldIncludeTitle = !routesWithoutTitle.includes(location.pathname);
  const shouldIncludeParams = !routeWithoutParams.includes(location.pathname);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenNotif = (event) => {
    setAnchorNotif(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(false);
  };

  const handleCloseNotif = () => {
    const ids = notifications
      .filter((el) => !el.is_read)
      .map((item) => item.id);
    setAnchorNotif(false);
    ids.map((el) => dispatch(updateNotification(el)));
  };

  const handleBack = () => {
    `/make-quizz/${params.quizzId}`.includes(location.pathname)
      ? history.push("/quizzes")
      : history.goBack();
  };

  const handleClose = () => {
    setOpenProfileSettings(false);
    localStorage.setItem("profile_settings", false);
  };

  const handleChangePassword = () => {
    setChangePassword(false);
  };

  const handleProfile = async () => {
    await dispatch(fetchProfile());
    setOpenProfileSettings(true);
    localStorage.setItem("profile_settings", true);
  };

  const handleNotification = (notif) => {
    console.log("notif", notif);

    if (notif?.message?.includes("has sent you a join invitation")) {
      dispatch(setOpenInvitationModal(notif?.account_uid));
    } else if (notif?.message?.includes("has generated a report")) {
      const extractOrgaId = (url) => {
        try {
          if (!url) return null;
          const parsed = new URL(url);
          let orgaId = parsed.searchParams.get("orga_id");
          if (orgaId) return orgaId;
          const redirect = parsed.searchParams.get("redirect");
          if (redirect && redirect.includes("orga_id")) {
            const qs = redirect.split("?")[1] || "";
            const sp = new URLSearchParams(qs);
            return sp.get("orga_id");
          }
          return null;
        } catch (e) {
          console.error("Error parsing URL:", e);
          return null;
        }
      };
      const orgaId = extractOrgaId(notif?.url);
      if (orgaId) {
        dispatch(setOrganizationId(orgaId));
        dispatch(getOrganizatonMetricsById(orgaId));
        localStorage.setItem("orgaId", orgaId);
      }
      window.open(notif?.url, "_blank");
    } else if (
      notif?.message?.includes("Your risk profile is available for review") ||
      notif?.message?.includes("has generated a risk profile")
    ) {
      // window.open(notif?.url, "_self");
      handleCloseNotif();
    } else if (notif?.url.length > 0) {
      const extractOrgaId = (url) => {
        try {
          if (!url) return null;

          // Normalize the URL to ensure parsing works
          const parsed = new URL(url);

          // Case 1: orga_id is in main query params
          let orgaId = parsed.searchParams.get("orga_id");
          if (orgaId) return orgaId;

          // Case 2: orga_id is inside the redirect param (your case)
          const redirect = parsed.searchParams.get("redirect");
          if (redirect && redirect.includes("orga_id")) {
            const qs = redirect.split("?")[1] || "";
            const sp = new URLSearchParams(qs);
            return sp.get("orga_id");
          }

          return null;
        } catch (e) {
          console.error("Error parsing URL:", e);
          return null;
        }
      };

      const orgaId = extractOrgaId(notif?.url);
      if (orgaId) {
        dispatch(setOrganizationId(orgaId));
        dispatch(getOrganizatonMetricsById(orgaId));
        localStorage.setItem("orgaId", orgaId);
      }

      window.open(notif?.url, "_blank");
      handleCloseNotif();
    }
  };

  return (
    <Toolbar
      sx={{
        display: "flex",
        justifyContent: "space-between",
        height: isMobile ? "80px" : "115px",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        display="flex"
        spacing={isMobile ? 0.5 : 0.5}
        columns={4}
        gap={0.5}
        height={isMobile ? "70%" : {}}

        // marginLeft={isMobile ? 0:4}
        // marginRight={isMobile ? 0:4}
      >
        {isMobile && (
          <Grid item>
            <MenuIcon style={{ color: "black" }} onClick={toggleAside} />
          </Grid>
        )}

        <Grid item xs={isMobile ? 0 : 3}>
          {shouldIncludeTitle && shouldIncludeParams ? (
            <p
              style={{
                fontFamily: "Bebas Neue",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: isMobile ? "18px" : "36px",
                lineHeight: isMobile ? "15px" : "43px",
                color: "black",
              }}
            >
              {displayTitle}
            </p>
          ) : !shouldIncludeParams ? (
            !location?.state && (
              <Typography
                variant="subtitle3"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "black",
                  cursor: "pointer",
                }}
                onClick={handleBack}
              >
                <IconButton>
                  <KeyboardBackspaceIcon
                    sx={{ width: "70%", color: "black" }}
                  />
                </IconButton>
                {t("back")}
              </Typography>
            )
          ) : null}
        </Grid>

        {/* <Grid
          item
          sx={{
            display: "flex",
            alignItems: "center",
            flexShrink: 0, // Prevents the grid item from shrinking
          }}
        >
          <Button
            variant="contained"
            sx={{
              py: 1, // Vertical padding
              px: 2, // Horizontal padding
              whiteSpace: "nowrap", // Prevents text wrapping
              minWidth: "auto", // Allows button to shrink to content
              "& .MuiButton-label": {
                width: "100%", // Ensures label takes full width
                overflow: "visible", // Ensures text is fully visible
              },
            }}
          >
            {t("launch_teaser_report")}
          </Button>
        </Grid> */}

        {/* <Grid item>
          <LanguageSelect />
        </Grid> */}
        {(role === "admin" ||
          role === "enterprise_admin" ||
          role === "cytailor_admin" ||
          role === "enterprise_user") && (
          <Grid item>
            <Badge
              onClick={handleOpenNotif}
              badgeContent={totalNotifs && totalNotifs}
              color="error"
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <IconButton sx={{ p: 0 }}>
                <NotificationsIcon style={{ fontSize: "30px" }} />
              </IconButton>
            </Badge>
            <Menu
              style={{
                marginTop: "45px",
                paddingTop: "10px",
                maxHeight: "800px",
              }}
              id="menu-appbar"
              anchorEl={anchorNotif}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorNotif)}
              onClose={handleCloseNotif}
            >
              {notifications?.length === 0 ? (
                <MenuItem
                  sx={{
                    height: "10px",
                    margin: "15px 0",
                  }}
                  disabled
                >
                  <Typography variant="title6">
                    {t("no_recent_notif")}
                  </Typography>
                </MenuItem>
              ) : (
                notifications
                  ?.sort((a, b) => b.id - a.id)
                  ?.map((notif) => (
                    <MenuItem
                      key={notif?.id}
                      sx={{
                        minHeight: "65px",
                        margin: "15px 0",
                        maxWidth: "450px",
                      }}
                      onClick={() => handleNotification(notif)}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          overflow: "hidden",
                          whiteSpace: "wrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <IconButton sx={{ p: 0 }}>
                          <NotificationsActiveIcon
                            style={{
                              fontSize: "25px",
                              color: !notif.is_read && "#78c3ae",
                            }}
                          />
                        </IconButton>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            variant="title6"
                            sx={{ color: "#2e3033" }}
                          >
                            {notif[translate("message")]}
                          </Typography>
                          <Typography variant="subtitle4">
                            {notif.timestamp || notif.sent_date}
                          </Typography>
                        </div>
                      </div>
                    </MenuItem>
                  ))
              )}
            </Menu>
          </Grid>
        )}

        <Grid item>
          <Tooltip title="Afficher le menu">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt={""} src={avatar} />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: "45px", pt: 3 }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem onClick={handleProfile}>
              <ListItemIcon>
                <Settings fontSize="small" />
              </ListItemIcon>
              {t("profil_settings")}
            </MenuItem>
            <MenuItem onClick={() => setChangePassword(true)}>
              <ListItemIcon>
                <LockResetOutlinedIcon fontSize="small" />
              </ListItemIcon>
              {t("change_password")}
            </MenuItem>
            <MenuItem
              onClick={() => {
                dispatch(logout(history));
                // dispatch(getOrganizatonMetricsById(null));
              }}
            >
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              {t("logout")}
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
      <ProfileSettings
        open={openProfileSettings}
        handleClose={handleClose}
        profile={profile}
      />
      <ChangePassword
        open={changePassword}
        handleClose={handleChangePassword}
      />
    </Toolbar>
  );
}

export default function Navbar({ toggleAside, isMobile }) {
  return (
    <Stack sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="primary" elevation={0}>
        {AppBarLabel("CYTAILOR", toggleAside, isMobile)}
      </AppBar>
    </Stack>
  );
}
